import { render, staticRenderFns } from "./NewFaqCategory.vue?vue&type=template&id=34dbf5f6&scoped=true&"
import script from "./NewFaqCategory.vue?vue&type=script&lang=js&"
export * from "./NewFaqCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dbf5f6",
  null
  
)

export default component.exports